import { Navigate, Outlet } from "react-router-dom";
import { useUserData } from "../data/providers/UserDataProvider";

export function RequireRole({ roles }: { roles: string[] }) {
  const userData = useUserData();
  if (userData.loading) return null;
  const allowed = userData?.data?.role && roles.includes(userData?.data.role);
  return allowed ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard/unauthorized" replace />
  );
}
